// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import ClaimProcessInvoice from '@deere/cps-it.warranty-model-factory/lib/invoice-claims-process';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import LabeledCurrency from '../../../../shared/components/labeled-currency/index';
import LabeledLink from '../../../../product/shared/components/labeled-link';
import LabeledNumber from '../../../../shared/components/labeled-number/index';
import LabeledString from '../../../../shared/components/labeled-string/index';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildClaimRoutes} from '../../../../shared/services/build-claim-route';
import {buildDate} from '../../../../shared/services/build-date';
import {buildDealer} from '../../../../shared/services/build-dealer';

const ClaimProcessInvoiceItem = props =>
    <section className='claim-process-invoice'>
        <div className='claim-link'>
            <LabeledLink
                className='claim-number'
                data={props.invoice.claimNumber}
                href={`#${buildClaimRoutes(props.invoice.claimType.key, props.invoice.subClaimType.key, props.invoice.claimNumber)}`}
                label='CLAIM_NUMBER'
            />
            {` ${props.invoice.claimType.value} ${props.invoice.subClaimType.value ? ` - ${props.invoice.subClaimType.value}` : ''}`}
        </div>
        <div className='row'>
            <LabeledString
                className='lost-two-column'
                data={buildDealer(props.dealer, props.user.settings.dealer.displayFormat.key)}
                label='DEALER_LOCATION'
            />
        </div>
        <div className='row'>
            <LabeledLink
                data={props.invoice.pin}
                href={`#/products/${props.invoice.pin}`}
                label='PIN'
            />
            <LabeledString
                data={props.invoice.referenceNumber1}
                label='WORK_ORDER_ONE'
            />
            <LabeledString
                data={props.invoice.referenceNumber2}
                label='WORK_ORDER_TWO'
            />
        </div>
        <div className='row'>
            <LabeledString
                data={props.invoice.status.value}
                label='STATUS'
            />
            <LabeledString
                data={buildDate(props.invoice.waitingForDealerInvoiceSince)}
                label='WAITING_SINCE'
            />
        </div>
        <div className='row'>
            <LabeledCurrency
                data={props.invoice.totalApprovedIncludingTaxes}
                label='TOTAL_APPROVED_INCLUDING_TAXES'
            />
            <LabeledString
                data={`${props.invoice.currency.value} (${props.invoice.currency.key})`}
                label='CURRENCY'
            />
            <LabeledString
                data={props.invoice.plant}
                label='PLANT'
            />
        </div>
        <div className='row'>
            <LabeledCurrency
                data={props.invoice.approvedParts}
                label='PARTS'
            />
            <LabeledCurrency
                data={props.invoice.approvedPartsAdditive}
                label='PARTS_ADDITIVE'
            />
            <LabeledCurrency
                data={props.invoice.totalApprovedClaimValue}
                label='CLAIM_VALUE'
            />
        </div>
        <div className='row'>
            <LabeledCurrency
                data={props.invoice.approvedLabor}
                label='LABOR'
            />
            <LabeledCurrency
                data={props.invoice.approvedLaborAdditive}
                label='LABOR_ADDITIVE'
            />
            <LabeledCurrency
                data={props.invoice.nonRecoverableTaxes}
                label='NON_RECOVERABLE_TAXES'
            />
        </div>
        <div className='row'>
            <LabeledCurrency
                data={props.invoice.approvedTravelTotal}
                label='TRAVEL'
            />
            <LabeledCurrency
                data={props.invoice.approvedOtherCredits}
                label='OTHER_CREDITS'
            />
            <LabeledCurrency
                data={props.invoice.recoverableTaxes}
                label='RECOVERABLE_TAXES'
            />
        </div>
        {props.invoice.harmcode &&
            <div>
                <div className='row'>
                    <LabeledString
                        data={props.invoice.harmcode}
                        label='HSN_SAC_CODE'
                    />
                    <LabeledString
                        data={props.invoice.gstPercentage}
                        label='GST_PERCENTAGE'
                        shouldTranslate={true}
                        values={{
                            gstPercentage: props.invoice.gstPercentage
                        }}
                    />
                    <LabeledCurrency
                        data={props.invoice.withholdValue}
                        label='TWO_PERCENT_WITHHOLD_VALUE'
                    />
                </div>
                <div className='row'>
                    <LabeledCurrency
                        data={props.invoice.igst}
                        label='IGST'
                    />
                    <LabeledCurrency
                        data={props.invoice.cgst}
                        label='CGST'
                    />
                    <LabeledCurrency
                        data={props.invoice.sgst}
                        label='SGST_UTGST'
                    />
                </div>
            </div>
        }
        {props.invoice.exchangeRate && props.invoice.exchangeRate > 0 ?
            <div className='row'>
                <LabeledNumber
                    data={props.invoice.totalAmountInLocalCurrency}
                    label='TOTAL_AMOUNT_IN_LOCAL_CURRENCY'
                    options={{minimumFractionDigits: 5}}
                />
                <LabeledNumber
                    data={props.invoice.exchangeRate}
                    label='EXCHANGE_RATE'
                    options={{minimumFractionDigits: 5}}
                />
            </div> : null}
    </section>;

ClaimProcessInvoiceItem.displayName = 'ClaimProcessInvoiceItem';
ClaimProcessInvoiceItem.propTypes = {
    dealer: PropTypes.instanceOf(Dealer).isRequired,
    invoice: PropTypes.instanceOf(ClaimProcessInvoice).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default ClaimProcessInvoiceItem;



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/claim-process-invoice/claim-process-invoice-item.js